import { connect } from 'react-redux';

import LoginRaxSsoPage from './LoginRaxSsoPage';
import { actionCreators } from '../../dux/user';

const mapDispatchToProps = {
  logInHandler: actionCreators.logInSSO,
};

export default connect(null, mapDispatchToProps)(LoginRaxSsoPage);
